import {
  Button,
  Container,
  createStyles,
  LoadingOverlay,
  MediaQuery,
  Modal,
  Paper,
  Text,
  TextInput,
  Image,
} from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { randomId } from "@mantine/hooks";
import { Pencil1Icon } from "@modulz/radix-icons";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import Toast from "./../Toast";
import { editWalinkApi, fetchWaLinksApi } from "../../api/dashboard";

const useStyles = createStyles((theme) => ({
  card: {
    position: "relative",
    overflow: "hidden",
    padding: theme.spacing.xl,
    width: "100%",

    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[6]
        : theme.colors.gray[0],
  },
  headBar: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    margin: 15,
    alignItems: "center",
    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[6]
        : theme.colors.gray[0],
  },
  domainCard: {
    position: "relative",
    cursor: "pointer",
    overflow: "hidden",
    transition: "transform 150ms ease, box-shadow 100ms ease",
    padding: theme.spacing.md,
    paddingLeft: theme.spacing.md * 2,

    "&:hover": {
      boxShadow: theme.shadows.md,
      transform: "scale(1.02)",
    },

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      width: 6,
      backgroundImage: theme.fn.linearGradient(
        0,
        "#00FFF0",
        "#3391FF",
        "#0063F8"
      ),
    },
  },
  button: {
    margin: 5,
  },
  buttonDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  backWa: {
    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[6]
        : theme.colors.gray[0],
  },
}));

async function editWalink(values) {
  const res = await editWalinkApi(values).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res == null) return;
  if (res.status == 200) {
    Toast("SUCCESS", res.data.message, "green");
    return res.data.newWaLink;
  } else {
    Toast("ERROR", res.data.message, "red");
    return;
  }
}

async function fetchWaLinks() {
  const res = await fetchWaLinksApi().catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res == null) return [];
  if (res.status == 200) {
    return res.data;
  } else {
    Toast("ERROR", res.data.message, "red");
    return [];
  }
}

/*
User FUNCTION MAPS SAMPLE DATA TO THE FORMAT 
{
  "edit":bool,
  "domain":string,
  "link",string
}
RETURNS ARRAY OF DOMAINPROPS
*/
function WaLinks(isAdmin, waLinks) {
  var domains = waLinks;
  if (domains.length == 0) return [];
  var edit = isAdmin ? true : false;

  var domainsProp = [];
  for (var domain in domains) {
    domains[domain].key = randomId();
    if (domains[domain].waLink != null) {
      domainsProp.push({
        edit: edit,
        domain: domains[domain].name,
        link: domains[domain].waLink,
        domainId: domains[domain].id,
      });
    } else {
      domainsProp.push({
        edit: edit,
        domain: domains[domain].name,
        domainId: domains[domain].id,
      });
    }
  }
  return domainsProp;
}

/*
ACCEPTS PARAMETERS edit:bool , link:string , domain:string
ALL PARAMETERS ARE OPTIONAL
"edit":true SHOULD BE PASSED FOR ADMIN
*/

function WaGroup(props) {
  const { classes, theme } = useStyles();
  const [opened, setOpened] = useState(false);
  const [walink, setwalink] = useState(props.link);
  const [isLoad, setLoad] = useState(false);
  const form = useForm({
    initialValues: {
      waLink: "",
      domainId: props.domainId,
    },
  });
  if (props.domain == null) {
    return (
      <Paper withBorder radius="md" className={classes.domainCard}>
        <Text style={{ fontSize: theme.fontSizes.lg }}>
          Links Will Be Available After Registeration
        </Text>
      </Paper>
    );
  } else {
    var title = props.domain;

    return (
      <>
        <Modal
          opened={opened}
          onClose={() => setOpened(false)}
          title={"Edit Group Link: " + props.domain}
        >
          <form
            onSubmit={form.onSubmit((values) => {
              setLoad(true);
              editWalink(values).then((newLink) => {
                setLoad(false);
                if (newLink != null) {
                  setwalink(newLink);
                }
              });
              setOpened(false);
            })}
          >
            <TextInput
              required
              placeholder="Group Link"
              data-autofocus
              {...form.getInputProps("waLink")}
            />
            <Button type="submit" fullWidth mt="md">
              Submit
            </Button>
          </form>
        </Modal>
        <Paper
          radius="md"
          className={classes.domainCard}
          style={{
            marginBottom: 10,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <LoadingOverlay visible={isLoad} />
          <Text
            size="md"
            weight={500}
            style={{
              display: "flex",
              alignItems: "left",
              fontSize: theme.fontSizes.lg,
            }}
          >
            {title}
          </Text>
          <Paper className={classes.buttonDiv}>
            <Button
              className={classes.button}
              style={{
                visibility: props.edit ? "visible" : "hidden",
                fontWeight: "normal",
              }}
              onClick={() => setOpened(true)}
            >
              <Pencil1Icon />
            </Button>
            <Image
              src="/whatsapp.svg"
              alt="whatsapp"
              style={{
                width: "30px",
                margin: "5px",
              }}
              onClick={() => {
                {
                  if (walink == null) Toast("Link not available", "", "red");
                  else window.open(walink);
                }
              }}
            />
          </Paper>
        </Paper>
      </>
    );
  }
}
WaGroup.propTypes = {
  domain: PropTypes.string,
  edit: PropTypes.bool,
  link: PropTypes.string,
  domainId: PropTypes.any,
};

export function WaGroups() {
  const isAdmin = localStorage.getItem("type") == "ADMIN" ? true : false;
  const { classes, theme } = useStyles();
  const [walink, setwalink] = useState([]);
  const [linksLoad, setlinksLoad] = useState(true);

  var links = WaLinks(isAdmin, walink).map((domainLink) => {
    if (domainLink.domain != null || domainLink.domainId != null) {
      return (
        <WaGroup
          key={randomId()}
          domain={domainLink.domain != null ? domainLink.domain : null}
          edit={domainLink.edit != null ? domainLink.edit : null}
          link={domainLink.link != null ? domainLink.link : null}
          domainId={domainLink.domainId != null ? domainLink.domainId : null}
        />
      );
    }
  });
  useEffect(() => {
    fetchWaLinks().then((res) => {
      setwalink(res);
      setlinksLoad(false);
    });
  }, []);

  return (
    <ModalsProvider>
      <MediaQuery smallerThan="sm" styles={{ width: "100%" }}>
        <MediaQuery largerThan="sm" styles={{ width: 700 }}>
          <Container style={{ maxwidth: 600, marginTop: 8,paddingLeft: "0px",
        paddingRight: "0px", }}>
            <Paper className={classes.card}>
              <MediaQuery largerThan="sm" styles={{ fontSize: 30 }}>
                <MediaQuery smallerThan="sm" styles={{ fontSize: 20 }}>
                  <Paper
                    className={classes.headBar}
                    style={{
                      fontFamily: "sans-serif",
                    }}
                  >
                    Whatsapp Links
                  </Paper>
                </MediaQuery>
              </MediaQuery>

              <Paper
                style={{
                  backgroundColor:
                    theme.colorScheme === "dark"
                      ? theme.colors.dark[6]
                      : theme.colors.gray[0],
                }}
              >
                <LoadingOverlay visible={linksLoad} />
                {links}
              </Paper>
            </Paper>
          </Container>
        </MediaQuery>
      </MediaQuery>
    </ModalsProvider>
  );
}
